import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { AngularFireModule } from '@angular/fire';
import {AngularFirestore, AngularFirestoreModule} from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import {AuthComponent} from './auth/auth.component';
import {AuthServiceService} from './auth/auth-service.service';
import { SignInComponent } from './sign-in/sign-in.component';
import { MainFeedComponent } from './main-feed/main-feed.component';
import { SearchComponent } from './search/search.component';
import { ProfileCandidateComponent } from './ProfileCandidate/ProfileCandidate.component';
import {ProfilComponent} from './profil/profil.component';
import { ElectionComponent } from './election/election.component';


export const environment = {
  production: true,
  firebaseConfig : {
    apiKey: 'AIzaSyAkVYD-jI84JJNqcdYuEY0rTnxaQllDPrQ',
    authDomain: 'gouvproject-64316.firebaseapp.com',
    databaseURL: 'https://gouvproject-64316.firebaseio.com',
    projectId: 'gouvproject-64316',
    storageBucket: 'gouvproject-64316.appspot.com',
    messagingSenderId: '336215206499',
    appId: '1:336215206499:web:80d962c545bb87894aa656',
    measurementId: 'G-N6XWRSZQ9T'
  }
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AuthComponent,
    SignInComponent,
    MainFeedComponent,
    SearchComponent,
    ProfileCandidateComponent,
    ProfilComponent,
    ElectionComponent
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebaseConfig),
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    AngularFirestoreModule, // Only required for database features
    AngularFireAuthModule, // Only required for auth features,
    AngularFireStorageModule, // Only required for storage features
    HttpClientModule
  ],
  providers: [AuthServiceService,
    AngularFirestore],
  bootstrap: [AppComponent]
})
export class AppModule { }
